module.exports = __webpack_public_path__ + "media/r_frischbier.6d476af6.mp3";